import React from 'react';

import Maybe from 'graphql/tsutils/Maybe';

import { ExcludeNil } from '@rbi-ctg/frontend';
import { INavigationTabFragment, INavigationTabsFragment } from 'generated/sanity-graphql';
import { LaunchDarklyFlagsObject } from 'utils/launchdarkly';

import { SanityNavMobileTab } from './sanity-nav-mobile-tab';
import { NavigationMobileTab } from './types';

export const checkFlagEnabled = (
  flags: LaunchDarklyFlagsObject,
  flagKey: Maybe<string>
): boolean => {
  return Boolean(flagKey && flags?.[flagKey]);
};

const alternateTabIsValid = (
  altMobileTab: INavigationTabFragment['launchDarklyAlternateMobileTab']
) => {
  return Boolean(
    altMobileTab?.tabIcon?.locale &&
      altMobileTab?.tabIconActive?.locale &&
      altMobileTab?.tabLink?.link &&
      altMobileTab?.tabIconActive?.locale
  );
};

export const generateNavigationMobileTabs = (
  sanityTabs: ExcludeNil<INavigationTabsFragment['navigationTabs']>,
  LDFlags: LaunchDarklyFlagsObject
): NavigationMobileTab[] => {
  return sanityTabs.reduce<NavigationMobileTab[]>((tabs, sanityNavMobileTab) => {
    const hideNavLinkLdFlag = sanityNavMobileTab?.hideLinkBasedOnLdFlag?.launchDarklyFlag;
    const shouldHideNavLink = checkFlagEnabled(LDFlags, hideNavLinkLdFlag);

    if (sanityNavMobileTab && !shouldHideNavLink) {
      const altSanityNavMobileTab = sanityNavMobileTab?.launchDarklyAlternateMobileTab;
      const LDFlagDependency = altSanityNavMobileTab?.launchDarklyFlagDependency?.launchDarklyFlag;
      const shouldShowAlternateLdNavLink =
        checkFlagEnabled(LDFlags, LDFlagDependency) && alternateTabIsValid(altSanityNavMobileTab);

      const alternateTabContents =
        shouldShowAlternateLdNavLink && altSanityNavMobileTab
          ? altSanityNavMobileTab
          : sanityNavMobileTab;

      tabs.push({
        selectedHrefs: [sanityNavMobileTab?.tabLink?.link?.locale || ''],
        Component: () => <SanityNavMobileTab {...alternateTabContents} />
      });
    }
    return tabs;
  }, []);
};
